import styled from "@emotion/styled";
import React from "react";
import { css } from "@emotion/core";
// import LomaLogo from "../../images/victor-over-triple/loma-logo.png";
// import WalkLogo from "../../images/victor-over-triple/we-walk-by-faith-logo.png";
import Butterfly from "../../images/victor-over-triple/butterfly-button.png";
import ButterflyClosed from "../../images/victor-over-triple/butterfly-button-closed.png";
// import BottomLeftBg from "../../images/victor-over-triple/bottom-left.png";
// import TopLefBg from "../../images/victor-over-triple/top-left.png";
import { colors, fonts, mediaQueries } from "../../configs/_configSite";
import VideoPLayerFullScreen from "../VideoPlayers/VideoPlayerFullScreen";
import VideoFile from "../../videos/vot-section-2-bg.mp4";
// import VideoFile5 from "../../videos/vot-section-3-top-left.mp4";
// import VideoFile2 from "../../videos/ribbon-hand.mp4";
import VideoFile3 from "../../videos/vot-fireworks.mp4";
// import ImgTopLeft from "../Images/VOT/ImgTopLeft";
import ImgTopLeftBackground from "../../images/victor-over-triple/loma-linda.jpg";
import ImgBottomLeftBackground from "../../images/victor-over-triple/we-walk-by-faith.jpg";

const Container = styled.section`
  position: relative;
  height: 100vh;
  width: 100vw;
`;

const BoxStyled = styled.section`
  width: 50vw;
  height: 50vh;
  position: absolute;
  box-sizing: border-box;
  text-align: center;
  background-size: cover;

  > img {
    max-width: 400px;
    width: auto;
    max-height: 100%;
    height: auto;
  }
  p {
    font-size: 18px;
    line-height: 125%;
  }
  @media (max-width: ${mediaQueries.lg}px) {
    width: 100vw;
    height: auto;
    position: relative;
    padding: 1rem 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    > img {
      max-width: 330px;
    }
    p {
      max-width: 450px;
      font-size: 14px;
    }
  }
  @media (max-width: ${mediaQueries.sm}px) {
    p {
      font-size: 14px;
    }
  }
  @media (max-width: ${mediaQueries.xs}px) {
    p {
      font-size: 11px;
    }
  }
`;

const TopLeftStyled = styled(BoxStyled)`
  top: 0;
  left: 0;
  background: url(${ImgTopLeftBackground}) center / contain no-repeat, #000000;
  padding: 12.5vh 7.67vw 12vh 21vw;
  @media (max-width: ${mediaQueries.lg}px) {
    height: 28vh;
  }
  @media (max-width: ${mediaQueries.xs}px) {
    height: 20vh;
  }
`;

// background-image: url(${BottomLeftBg});
const BottomLeftStyled = styled(BoxStyled)`
  bottom: 0;
  left: 0;
  background: url(${ImgBottomLeftBackground}) center / contain no-repeat,
    #000000;
  padding: 11vh 6vw 11vh 20vw;
  @media (max-width: ${mediaQueries.lg}px) {
    height: 28vh;
  }
  @media (max-width: ${mediaQueries.xs}px) {
    height: 20vh;
  }
`;

const TopRightStyled = styled(BoxStyled)`
  top: 0;
  right: 0;
  background: #fff;
  padding: 12vh 19vw 12vh 7.67vw;

  p {
    color: #000000;
  }
  img {
    top: -136px;
    left: -50px;
    transform-origin: bottom left !important;
  }
  @media (max-width: ${mediaQueries.lg}px) {
    height: 22vh;
    a {
      margin-top: 20px;
    }
  }
  @media (max-width: ${mediaQueries.xs}px) {
    height: 24vh;
    img {
      top: -176px;
      left: -20px;
      transform: scale(0.2);
    }
    a {
      margin-top: 10px;
    }
  }
`;

const BottomRightStyled = styled(BoxStyled)`
  bottom: 0;
  right: 0;
  background: #213e8c;
  padding: 12vh 19vw 12vh 7.67vw;

  p {
    color: #fff;
  }
  img {
    bottom: -100px;
    left: -120px;
  }

  @media (max-width: ${mediaQueries.lg}px) {
    height: 22vh;
    a {
      margin-top: 0px;
      margin-bottom: 20px;
    }
  }
  @media (max-width: ${mediaQueries.xs}px) {
    height: 24vh;
    img {
      bottom: -110px;
      left: -140px;
    }
  }
`;

const ButtonStyled = styled.a`
  background: #ffffff;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  font-family: ${fonts.primary};
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 1.25;

  text-decoration: none;
  display: inline-block;
  padding: 15px 60px;
  text-align: center;

  margin: 0 auto;
  box-sizing: border-box;
  color: #000000;
  position: relative;
  margin-top: 12%;
  transition: all 0.2s;
  img {
    position: absolute;

    transform: scale(0.5);
    transform-origin: top right;
  }

  &:hover {
    background-color: ${colors.gold};
    color: #fff;
  }
  @media (max-width: ${mediaQueries.xs}px) {
    font-size: 12px;
    padding: 13px 50px;
    img {
      transform: scale(0.3);
    }
  }
`;

export default () => {
  return (
    <Container>
      <TopLeftStyled />
      <TopRightStyled>
        <VideoPLayerFullScreen video={VideoFile} cssProp="height: 120%;" />
        <p
          css={css`
            position: relative;
            color: #ffffff !important;
          `}
        >
          Loma Linda University Health
        </p>
        <ButtonStyled
          href="https://giving.lluh.org/site/Donation2;jsessionid=00000000.app271a?idb=1930131919&DONATION_LEVEL_ID_SELECTED=1&df_id=2602&mfc_pref=T&2602.donation=form1&NONCE_TOKEN=D74F3567A2DDAD31E0AC4CADED6D6A82&idb=0"
          target="_blank"
          css={css``}
        >
          <img src={ButterflyClosed} alt="Butterfly" />
          Donate
        </ButtonStyled>
      </TopRightStyled>
      <BottomLeftStyled>
        <VideoPLayerFullScreen video={VideoFile3} cssProp="height: 120%;" />
      </BottomLeftStyled>

      <BottomRightStyled>
        <VideoPLayerFullScreen video={VideoFile3} cssProp="height: 120%;" />
        <p
          css={css`
            position: relative;
            color: #ffffff !important;
          `}
        >
          We Walk By Faith Cancer Foundation...
        </p>
        <ButtonStyled href="https://www.wewalkbyfaithcancerfoundation.com/?fbclid=IwAR1hEAtYopCLaQ39779ly1kDy2jVWa-EMAHtGSeTYcfQtlGdrmgZLhbY3rQ">
          <img src={Butterfly} alt="Butterfly" />
          Donate
        </ButtonStyled>
      </BottomRightStyled>
    </Container>
  );
};
